import { render } from "./StepStrictly.vue?vue&type=template&id=fa7a808e"
import script from "./StepStrictly.vue?vue&type=script&lang=js"
export * from "./StepStrictly.vue?vue&type=script&lang=js"
script.render = render

export default script